/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForJiraServiceManagement extends models.ServiceAccountCredentialsBase {
    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForJiraServiceManagement.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForJiraServiceManagement>): ServiceAccountCredentialsBaseForJiraServiceManagement {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForJiraServiceManagement(), model);
        ServiceAccountCredentialsBaseForJiraServiceManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForJiraServiceManagement>): ServiceAccountCredentialsBaseForJiraServiceManagement {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForJiraServiceManagement.newInstance(<ServiceAccountCredentialsBaseForJiraServiceManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForJiraServiceManagement) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForJiraServiceManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForJiraServiceManagement): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForJiraServiceManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
